import axios from '../request/http';

const apply = {
    // 邀请人列表
    applyList(params) {
        return axios.get("/admin/commerce-activity/user/list", { params });
    },
     // 活动列表
     activityList(params) {
        return axios.get("/admin/commerce-activity/list", { params });
    },
    // 活动新增/编辑
    activityEdit(data){
        return axios.post("/admin/commerce-activity/edit", data );
    },
    // 活动状态更新
    activityStatus(params){
        return axios.get("/admin/commerce-activity/status/update", { params });
    },
    // 活动人员新增编辑
    activityAddUser(data){
        return axios.post("/admin/commerce-activity/user/edit", data);
    },
    // 用户报名信息导出
    activityExportUser(params){
        return axios.get("/admin/commerce-activity/user/list/export", { params ,responseType: 'arraybuffer'});
    },
    // 用户报名信息导入
    activityImportUser(data){
        return axios.post("/admin/commerce-activity/user/import", data);
    },
      // 用户报名信息下载模板
    activityDownloadModelUser(data){
        return axios.post("/admin/commerce-activity/downloadModel", data);
    },
    // 删除邀请人
    delApply(params) {
        return axios.get("/admin/activity-module/list", { params });
    },
}

export default apply;


// WEBPACK FOOTER //
// ./src/api/apply.js